import React from 'react'
import { Helmet } from 'react-helmet-async'
import { ErrorReportsLayout } from '../../layouts/Analytics'
import type { AnalyticsAPIResponse } from '../../interfaces'

interface Props {
  data: AnalyticsAPIResponse | null
}

const ErrorReportsPage = ({ data }: Props): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Error Reports</title>
      <meta name="description" content="Error Reports page" />
    </Helmet>
    <ErrorReportsLayout {...{ data }} />
  </React.Fragment>
)

export default ErrorReportsPage
